import React from 'react';
import { BOOKING_URL, PRICE, agent } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="w-full bg-ink-950" data-id="element-46" data-mp="22d2xik5fi9xm">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center md:py-20" data-id="element-47" data-mp="1no6qmqf3z2yl">
        <h2 id="final-title" className="font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-48" data-mp="1snax39aneml8">
          Antes de tomar la próxima decisión, consultalo con un profesional.
        </h2>
        <p className="mt-4 text-[16px] text-body" data-id="element-49" data-mp="1irgay477u9dp">
          Videollamada con {agent.name} · {agent.credential}
        </p>
        <div className="mt-8" data-id="element-50" data-mp="14s8al7zbgv7x">
          <CtaButton size="xl" href={BOOKING_URL} data-id="element-51" data-mp="19oov7s7b4rg9" />
        </div>
        <p className="mt-4 text-sm text-subtle" data-id="element-52" data-mp="19rb4bw9ujf0l">{PRICE} · Pago seguro mediante Mercado Pago</p>
      </div>
    </section>;
}